import type { SiteDocument } from '../types/siteRag';
import type { SiteEvidenceDocument } from '../types/siteEvidence';

const EXTRACTION_FAILURE = /(?:\b(?:cannot|can't|unable to|could not)\s+(?:access|read|extract|process|view)\b|\b(?:extraction|processing)\s+(?:failed|unavailable)\b)/i;

/** Read-only preview from the report's exact SED when live metadata still
 * contains an earlier extraction failure. A summary alone is not proof
 * that the source was recovered, and visual readings remain screening. */
export function reportDocumentPreview(
  doc: SiteDocument | undefined,
  sed: SiteEvidenceDocument | undefined,
  reportSedId: string | undefined,
): string {
  const summary = doc?.summary ?? '';
  if (!doc || !EXTRACTION_FAILURE.test(summary) || !reportSedId || sed?.id !== reportSedId) return summary;
  const source = sed.uploadedDocuments?.find(row => row.docId === doc.id && row.fileName === doc.fileName);
  if (!source?.textContent?.trim() || EXTRACTION_FAILURE.test(source.textContent)) return summary;
  const visual = source.visualReadings?.find(row => row.channel === 'vision'
    && Number.isFinite(row.confidence) && row.confidence > 0
    && row.transcription?.trim() && source.textContent?.includes(row.transcription));
  const indexed = source.contentIndex?.some(row => row.summary?.trim()) === true;
  if (!visual && !indexed) return summary;
  const preview = visual?.transcription?.trim() ?? source.textContent.trim();
  const bounded = preview.length > 220 ? `${preview.slice(0, 220)}…` : preview;
  return `${visual ? 'Source transcription (visual screening; not provider verification)' : 'Extracted source preview'} from the report SED: ${bounded}`;
}
